/* unplugin-vue-components disabled */import { render } from "./footerView.vue?vue&type=template&id=6380b83d&scoped=true"
const script = {}

import "./footerView.vue?vue&type=style&index=0&id=6380b83d&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6380b83d"]])

export default __exports__